export default __webpack_public_path__ + "static/media/send-white.aa4b4d6f.svg";